<div class="row mb-1">
  <div class="col-" *ngIf="!_isClosed">
    <label class="ml-3"> Add/Remove:</label>
    <span matTooltip="Add/Remove invoice reference" class="me-2 pe-2 icon-mat" (click)="add()">
      <i class="bi bi-plus-slash-minus"></i>
    </span>
  </div>
</div>
<div class="row mb-1">
  <div class="col-span-full">
    <mat-chip-list #chipList aria-label="Invoice reference selection">
      <mat-chip *ngFor="let invref of selectedInvoiceRef; index as i">
        {{ invref.type_code }} : {{ invref.type_value }}
        <i class="bi bi-x icon-close" (click)="remove(invref)" *ngIf="!_isClosed"></i>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
